import { useState, useEffect } from 'react';
import styled from 'styled-components';
import "@fontsource/source-sans-pro";
import '../../../../index.css';
import { useLocation, useNavigate } from "react-router-dom";
import { useEndpointProvider } from '../../../../Providers/EndpointProvider';
import { FRONTEND_LINKS } from '../../../../Constants/FrontendLinks';
import { InfoMessage, WarningMessage, ErrorMessage, SuccessMessage } from '../../../../Constants/StyledComponents';
import ModernMUITable from '../../../../Components/ModernMUITable';
import { localizeDate } from '../../../../Computation/utilFunctions';
import SubpageTabs from '../../../../Components/SubpageTabs/SubpageTabs';
import { SubHeader } from '../Subpages/Components/SubHeader';
import { useBackendLinksProvider } from '../../../../Providers/BackendLinksProvider';

const UploadHistorySubpage = () => {
    const endpointProvider = useEndpointProvider()
    const location = useLocation()
    const { LINKS } = useBackendLinksProvider()

    let navigate = useNavigate()

    const query = new URLSearchParams(useLocation().search);
    const UID = parseInt(query.get("patient_id"))

    const [patient, setPatient] = useState(location?.state)

    useEffect(() => {
        async function getPatient() {
            let body = {
                patient_primary_key: UID,
            }

            if (UID === undefined) {
                alert(`patient_id === undefined`)
                navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)
            }

            try {
                const patientData = await endpointProvider.post(LINKS.DATA.PROFILING.GET_PATIENT, body)
                return patientData
            } catch (error) {
                alert(`Patient id=${UID} does not exist.`)
                navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)
            }
        }

        if (!patient || Object.keys(patient).length === 0) {
            getPatient().then(patientData => {
                setPatient(patientData)
            })
        }
    }, [UID])

    const columns = [
        { field: "_timestamp", headerName: "Uploaded", valueGetter: (value, row) => localizeDate(Date.parse(row._timestamp)), minWidth: 200, visible: true, flex: 1 },
        { field: "email", headerName: "Uploaded By", minWidth: 160, visible: true, valueGetter: (value, row) => { return row.email }, flex: 1 },
        {
            field: "combined_message", headerName: "Most Recent Message", minWidth: 300, visible: true, renderCell: params => {
                const combined_message = params.row.combined_message
                if (!combined_message) return null

                let messageString = "";
                if (typeof combined_message === 'string') {
                    messageString = combined_message;
                } else if (typeof combined_message === 'object' && combined_message !== null) {
                    if (combined_message.message) {
                        messageString = String(combined_message.message);
                    } else if (combined_message.error) {
                        messageString = String(combined_message.error);
                    } else if (combined_message.description) {
                        messageString = String(combined_message.description);
                    } else if (combined_message.text) {
                        messageString = String(combined_message.text);
                    } else {
                        const keys = Object.keys(combined_message);
                        if (keys.length > 0) {
                            const keyValuePairs = keys.slice(0, 3).map(key => 
                                `${key}: ${String(combined_message[key])}`
                            ).join(', ');
                            messageString = `Object data: ${keyValuePairs}${keys.length > 3 ? '...' : ''}`;
                        } else {
                            messageString = "Empty object";
                        }
                    }
                } else {
                    messageString = String(combined_message) || "No message available";
                }


                const words = messageString.split(" ");
                const messageType = words[0] ? words[0].replace("!", "") : ""

                const firstWord = words[0] ? words[0].charAt(0).toUpperCase() + words[0].slice(1) : "";
                const restOfMessage = words.length > 1 
                    ? (words.slice(1).join(" ").length > 50 
                        ? words.slice(1).join(" ").slice(0, 50) + "..." 
                        : words.slice(1).join(" "))
                    : "";

                const MessageComponent = {
                    info: InfoMessage,
                    success: SuccessMessage,
                    error: ErrorMessage,
                    warning: WarningMessage,
                    canceled: CanceledMessage
                }[messageType];

                if (!MessageComponent) return null;

                return (
                    <MessageComponent>
                    <p>
                        <strong>{firstWord}</strong>
                        {restOfMessage && " " + restOfMessage}
                    </p>
                    </MessageComponent>
                );
            },
            flex: 1
        },
    ]

    const uploadTableToolbarProps = {
        createButton: { title: "Upload patient", isShow: false },
        deleteButton: { title: "Delete", isShow: false, },
        filterButton: { title: "Filter", isShow: false },
        exportButton: { isShow: false },
        searchInput: { isShow: true },
        mainTable: true
    }


    return (
        <div>
            

            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "6px 0px", marginTop: "8px", marginBottom: "16px", marginLeft: "32px", marginRight: "32px", borderBottom: "1px solid var(--color-border-default)", paddingBottom: "12px" }}>
                <SubHeader patient={patient} />
                <SubpageTabs UID={UID} patient={patient} currentTab={'Uploads'} />
            </div>
            
            <div style={{ 
                padding: "0 32px", 
                display: "block", 
                marginTop: "16px", 
                height: 'calc(100vh - 200px)',
                minHeight: '500px',
                maxHeight: '80vh'
            }}>
                <ModernMUITable
                    queryKey="upload"
                    endpoint={LINKS.DATA.UPLOAD.GET_UPLOAD_MESSAGES}
                    body={{ patient_id: UID }}
                    columns={columns}
                    tableToolbarProps={uploadTableToolbarProps}
                    checkboxSelection={false}
                    isRowSelectable={() => false}
                    height="100%"
                    paginationMode="client"
                    sortingMode="client"
                />
            </div>
        </div>
    )
};

const CanceledMessage = styled.div`
	background: rgba(238, 161, 12, 0.2);
	height: 30px;
	padding: 8px 8px;
	border-radius: 6px;
	p {
		color: rgb(238, 161, 12);
	}
`;

export default UploadHistorySubpage;